import { post } from "../fetch";

export function createPrivateChat() {
  document.addEventListener("DOMContentLoaded", () => {
    const buttons = document.querySelectorAll(".private-ticket-button");
    if (!buttons) {
      return;
    }
    buttons.forEach((button) => {
      button.addEventListener("click", async () => {
        const spinner = button.querySelector(".private-ticket__spinner");
        const orderId = button.getAttribute("data-order-id") || "";
        // @ts-ignore
        spinner && (spinner.style.visibility = "visible");
        buttons.forEach((button) => {
          button.setAttribute("disabled", "disabled");
        });
        await createPrivateChatAjax(orderId);
        // @ts-ignore
        spinner && (spinner.style.visibility = "hidden");
      });
    });
  });
}

async function createPrivateChatAjax(orderId: string) {
  // @ts-ignore
  const ajaxUrl = window?.ystdssScriptsData?.ajaxUrl;
  try {
    const response = await post(ajaxUrl, {
      action: "create_private_chat",
      orderId: orderId,
    });
    const data = await response.json();
    if (response.ok) {
      showMessage(data.message);
    } else {
      showMessage(data.message, "error");
    }
  } catch (e) {
    // @ts-ignore
    console.error(e.message);
  }
}

function showMessage(message: string, type = "success") {
  const element = document.getElementById(`private-ticket-message--${type}`);
  if (element) {
    element.style.display = "block";
    element.style.opacity = "1";
    element.innerText = message;

    setTimeout(() => {
      element.style.opacity = "0";
    }, 2000);
    setTimeout(() => {
      element.style.display = "none";
    }, 3000);
  }
}
